






































import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';

@Component
export default class Breadcrumb extends Vue {
    private routes: Array<RouteConfig> = new Array<RouteConfig>();

    @Watch('$route', { deep: true })
    private onRouteChanged(): void {
        this.generateBreadcrumb();
    }

    private onBack(): void {
        if (this.routes.length === 1) {
            return;
        }

        this.$router.back();
    }

    private generateBreadcrumb(): void {
        const routes = this.$route.matched
            .filter((route) => {
                return route.meta.ignoreBreadcrumb !== true;
            })
            .map((route) => {
                return { name: route.name, path: route.path, meta: route.meta };
            });

        const home = routes.find((route) => route.name === 'home');

        if (home == null) {
            routes.unshift({ name: 'home', path: '', meta: { title: 'Home' } });
        }

        this.routes = routes;
    }

    private created(): void {
        this.generateBreadcrumb();
    }
}
